type AnimateOptions = {
	from: number;
	to: number;
	durationMs: number;
};

type AnimateCallback = (data: {value: number; done: boolean}) => void;

export function animate({from, to, durationMs}: AnimateOptions, callback: AnimateCallback) {
	const startTime = Date.now();

	raf();

	function raf() {
		const currentTime = Date.now();
		const part = (currentTime - startTime) / durationMs;
		const value = from + part * (to - from);

		if ((to > from && to - value < 0) || (to < from && to - value > 0)) {
			return callback({value, done: true});
		}

		callback({value, done: false});
		window.requestAnimationFrame(raf);
	}
}
